import { activePivots, agentHref, logsHref } from '../../lib/logs/investigation.ts'
import type { LogInvestigation, PivotChip } from '../../lib/logs/investigation.ts'
import { Link } from '../../lib/router.tsx'

/**
 * O banner de investigação ativa.
 *
 * Aparece quando a lista está filtrada por um pivô — processo, IP, usuário,
 * hash (§9–§11).
 *
 * Cada pivô traz um "limpar" que navega para a URL sem aquele parâmetro; o
 * escopo de agente (o segmento de rota) é preservado, porque limpar um pivô não
 * é sair da máquina.
 */
export function InvestigationBanner({
  inv,
  endpointId,
}: {
  inv: LogInvestigation
  endpointId?: string
}) {
  const pivots = activePivots(inv)
  if (pivots.length === 0) return null

  const hrefWithout = (key: PivotChip['key']): string => {
    const next: LogInvestigation = { ...inv, [key]: undefined }
    return endpointId === undefined ? logsHref(next) : agentHref(endpointId, next)
  }

  return (
    <div className="border-l-2 border-accent px-3 py-2">
      <div className="flex flex-wrap items-center gap-1.5">
        <span className="text-micro font-medium uppercase tracking-label text-accent">
          Investigação
        </span>
        {pivots.map((pivot) => (
          <span
            key={pivot.key}
            className="inline-flex max-w-full items-center gap-1 border border-line-strong px-1.5 py-0.5 text-micro"
          >
            <span className="uppercase tracking-label text-fg-muted">{pivot.label}</span>
            <span className="min-w-0 max-w-[18rem] truncate font-mono text-fg">{pivot.value}</span>
            <Link
              href={hrefWithout(pivot.key)}
              aria-label={`Limpar filtro ${pivot.label}`}
              title="Limpar este filtro"
              className="text-fg-muted hover:text-fg"
            >
              ✕
            </Link>
          </span>
        ))}
      </div>
    </div>
  )
}
